import * as APP_CONFIG from "../constants/config";
const {benchmarkApi} = APP_CONFIG;

export function inactiveInvertersSet(inactiveInverters) {
    return {
        type: 'INACTIVE_INVERTERS_SET',
        inactiveInverters
    };
}

function systemIdsSet(systemIds) {
    return {
        type: 'SYSTEMIDS_SET',
        systemIds
    };
}

function invertersYearSet(invertersYear) {
    return {
        type: 'INVERTERSYEAR_SET',
        invertersYear
    };
}

const daysAgoColor = (days) => {
    let color = "yellow";
    if(days > 3)
        color = "orange";
    if(days > 14)
        color = "red";
    return color;
}


export function fetchInactiveInverters(todayInverters, force = false) {

    return async (dispatch, getState) => {

        let {notifications, monthItems} = getState();

        let {systemIds} = notifications;

        console.log(monthItems)
        //const todayInverters = ...todayInverters;
        //console.log(`todayInverters # ${todayInverters.length}`);

        const monthKeys = Object.keys(monthItems).filter(element => element !== 'week');
        monthKeys.sort();
        monthKeys.reverse();

        if(systemIds.length===0 || force){
            const request = await fetch(`${benchmarkApi}inverters`);
            systemIds = await request.json();
            systemIds = systemIds.filter(inv => inv.active);

            dispatch(systemIdsSet(systemIds));

        }
        else {
            console.log(`systemIds niet leeg`);
        }

        let inactiveInverters = [];

        systemIds.forEach((inverter) => {
            if(!inverter || !inverter.ever_active)
                return;

            const today = todayInverters.find(item => item.systemId === inverter.id);

            if(today && today.cp > 0)
                return;

            let daysAgo = 1;

            for(let idx in monthKeys){
                const key = monthKeys[idx];
                let items = monthItems[key]
                if(!items.length)
                    items = [];
                const day = items.find(item => item.systemId === inverter.id);
                if(day && day.cp > 0)
                {
                    inactiveInverters.push({...inverter, daysAgo: daysAgo, color: daysAgoColor(daysAgo)});
                    return;
                }
                daysAgo++;
            }

            inactiveInverters.push({...inverter, daysAgo: `> ${daysAgo}`, color: daysAgoColor(daysAgo)});

        });

       dispatch(inactiveInvertersSet(inactiveInverters));

    };

}


export function fetchInvertersYear(year = 0) {
    if(!year)
        year = (new Date()).getFullYear();
    return async (dispatch, getState) => {
        const request = await fetch(`${benchmarkApi}benchmark/invertersyear/${year}`);
        const invertersYear = await request.json();
        dispatch(invertersYearSet(invertersYear));

    };
}







// WEBPACK FOOTER //
// ./src/actions/notifications.js